import "core-js/modules/es.array.push.js";
export default {
  name: "cmsHeader",
  data() {
    return {
      nav: [{
        name: "首页",
        path: "/home",
        components: ["home"]
      }, {
        name: "招商展示",
        path: "/exhibition",
        components: ["exhibition"]
      },
      // {
      //     name: "产品介绍",
      //     path: "/product",
      //     components: ["product", "productDetail"]
      // },
      {
        name: "客户服务",
        path: "/customer",
        components: ["customer"]
      },
      // {
      //   name: "自助订单",
      // path: "/order",
      // components: ["order"]
      //},
      {
        name: "动态新闻",
        path: "/new",
        components: ["new", "newDetail"],
        // TODO: 确定路径
        dropdownList: [{
          name: "行业资讯",
          path: "/new"
        }, {
          name: "公司动态",
          path: "/new"
        }, {
          name: "员工生活",
          path: "/new"
        }]
      }, {
        name: "加入我们",
        path: "/position",
        components: ["position", "positionDetail"]
      }, {
        name: "关于我们",
        path: "/about",
        components: ["about"]
      }],
      fixed: false
    };
  },
  computed: {
    page() {
      return String(this.$route.name || "");
    }
  },
  methods: {
    goInner() {
      window.open("https://employee.91jkys.com/");
    },
    goNav(path) {
      this.$router.push(path);
    }
  },
  created() {
    window.addEventListener("scroll", () => {
      let scroll_top = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scroll_top = document.documentElement.scrollTop;
      } else if (document.body) {
        scroll_top = document.body.scrollTop;
      }
      this.fixed = scroll_top > 0;
    }, true);
  }
};